import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'swiper/angular';

import { LoginRoutingModule } from './login-routing.module';
import { LoginFormComponent } from './login-form/login-form.component';
import { HomepageComponent } from './homepage/homepage.component';
import { RouterModule } from '@angular/router';
import { CarouselComponent } from './homepage/carousel/carousel.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [LoginFormComponent, HomepageComponent, CarouselComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    RouterModule,
    SwiperModule,
    NgbModule
  ]
})
export class LoginModule { }
